// apiThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchApiData = createAsyncThunk(
  'apiData/fetchApiData',
  async (_, { getState }) => {
    console.log("Thunk started...");
    const sessionToken = localStorage.getItem('token');
    if (!sessionToken) {
      throw new Error('No session token found in localStorage');
    }

    const response = await axios.get('https://v4.dhundhoo.com/v2/account/my', {
      headers: {
        'x-dhundhoo-session': sessionToken,
      },
    });
    return response.data;
  }
);